import React from 'react';
import './QuizTaker.css';
import QuizTakerContainer from './quiz/QuizTakerContainer';
import { AppBook } from '../types/utils';

interface QuizTakerProps {
  book: AppBook;
  defaultQuestionType: 'true_false' | 'multiple_choice';
  selectedBook: string;
  selectedChapter: string;
  availableBooks: string[];
  availableChapters: string[];
  onBookChange: (bookId: string) => void;
  onChapterChange: (chapterId: string) => void;
}

const QuizTaker: React.FC<QuizTakerProps> = (props) => {
  return <QuizTakerContainer 
    book={props.book}
    defaultQuestionType={props.defaultQuestionType}
    selectedBook={props.selectedBook}
    selectedChapter={props.selectedChapter}
    availableBooks={props.availableBooks}
    availableChapters={props.availableChapters}
    onBookChange={props.onBookChange}
    onChapterChange={props.onChapterChange}
  />;
};

export default QuizTaker; 